export default __webpack_public_path__ + "static/media/grrs_map_mobile.e0ae9d77.svg";